@if (embedded) {
    <button class="notepad-list__close-button"
            (click)="close()"
            [attr.aria-label]="'generic.close' | translate"
            [matTooltip]="'generic.close' | translate">
        <mat-icon svgIcon="cross"></mat-icon>
    </button>
}

<app-banner-info [rolesCanShowBanner]="rolesCanShowBannerInfo"
                    situation="notepad-list">
</app-banner-info>

<mat-toolbar class="notepad-list__filters filters">
    <mat-toolbar-row class="notepad-list__filter-row">
        <app-search-filters (launchSearch)="refreshNotes($event).subscribe()"
                            [countEntities]="paginator?.count"
                            [fields]="filters"
                            [overrideEndpointFilterName]="[{originalFilterName: 'lessons', targetFilterName: 'associated_node'}]"
                            [customFieldName]="[{field: 'metadatas_title', value: 'generic.title'}]">
        </app-search-filters>
    </mat-toolbar-row>
</mat-toolbar>

@if (isLoadingDone) {
    <div class="notepad-list__cards">
        <button class="notepad-list__add-button"
                (click)="createNote($event)"
                (keyup.enter)="createNote($event)">
            <mat-icon svgIcon="add"></mat-icon>
            <span>{{ 'notepad.add_note' | translate }}</span>
        </button>
        @for (notepad of notepads; track $index) {
            <app-notepad-card (hasChanged)="onNotepadChanged(notepad)"
                                [notepadBasicSearchEntity]="notepad"
                                [embedded]="embedded"
                                [forceAssociationOnSave]="forceAssociationOnSave"
                                (actionTriggered)="onActionTriggered($event)">
            </app-notepad-card>
        }
    </div>
    <mat-paginator (page)="onPaginateChange($event)"
                    [length]="paginator.count"
                    [pageIndex]="paginator.page -1"
                    [pageSize]="notepadListRange">
    </mat-paginator>
} @else {
    <mat-spinner></mat-spinner>
}
